import * as NavigationMenu from '@radix-ui/react-navigation-menu'
import { BreadcrumbItem } from '../types'
import { BreadcrumbItemDesktop } from './BreadcrumbItemDesktop'

interface BreadcrumbDesktopProps {
  items: BreadcrumbItem[]
}

export function BreadcrumbDesktop({ items }: BreadcrumbDesktopProps) {
  return (
    <div className="hidden sm:flex items-center gap-1">
      {items.map((item, index) => (
        <BreadcrumbItemDesktop
          key={index}
          item={item}
          index={index}
          showIcon={Boolean(item.icon && index === 0)}
        />
      ))}
    </div>
  )
}
